<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <h3 :class="['title', 'font-grey', 'font-l-600']">Primary Colors</h3>
    <vc-layout :spacing="8" :class="['primary-colors', 'align-center']">
      <vc-col :span="4" v-for="color in primaryColors" :key="color" sm8 xs12>
        <div :class="[color, 'elevation-6']">
          <code>{{ color }}</code>
        </div>
      </vc-col>
    </vc-layout>

    <h3 :class="['title', 'font-grey', 'font-l-600']">Color Swatches</h3>
    <vc-layout :class="['swatches-list']" :spacing="8">
      <vc-col :span="8" v-for="(color, index) in colors" :key="index" sm12 xs24>
        <ul>
          <li>
            <div :class="['vc-table-layout', 'vc-dark', color.color]">
              <div>
                <div>
                  <h4 :class="['ellipsis']">{{ color.color }}</h4>
                </div>
                <div :class="['align-right']">
                  <div :class="['ellipsis']">
                    <code>{{ color.hex }}</code>
                  </div>
                </div>
              </div>
            </div>
            <ul>
              <li v-for="(item, index) in color.items.filter(clr => clr.hue)" :key="item.hex">
                <div :class="['vc-table-layout', item.color, item.hue, index > 4 && index < 9 ? 'vc-dark' : 'vc-light']">
                  <div>
                    <div>
                      <div :class="['ellipsis']">
                        <span>back:</span> <code>"{{ color.color }} {{ item.hue }}"</code>
                      </div>
                    </div>
                    <div :class="['align-right']">
                      <div :class="['ellipsis']">
                        <code>{{ item.hex }}</code>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div :class="['ellipsis']">
                        <span>font:</span> <code>"font-{{ color.color }} font-{{ item.hue }}"</code>
                      </div>
                    </div>
                    <div :class="['align-right']">
                      <div :class="['ellipsis']">
                        <code>{{ item.hex }}</code>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ColorsPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      colors: [],
      primaryColors: ['default', 'primary', 'info', 'warning', 'success', 'error']
    }
  },
  mounted () {
    this.$root.$emit(this.$store.state.events.ajaxStart)
    this.$http('/static/data/color-swatches.json').then(response => {
      response = response.data.colors
      const colors = response.filter(color => !color.hue)
      colors.forEach(color => {
        color.items = response.filter(item => item.color === color.color)
      })
      this.colors = colors
      this.getPage()
    })
  }
}
</script>
<style>
.swatches-list ul,
.swatches-list li,
.swatches-list h4
{
  margin: 0;
  padding: 0;
  list-style: none;
}

.swatches-list .vc-dark.white,
.swatches-list .vc-dark.transparent
{
  color: #000;
}

.primary-colors,
.swatches-list .vc-dark
{
  color: #fff;
}

.primary-colors .vc-col > div,
.swatches-list .vc-table-layout
{
  font-size: 13px;
}

.primary-colors .vc-col > div,
.swatches-list .vc-table-layout > * > *
{
  padding: 8px;
}

.primary-colors .vc-col > div
{
  font-weight: 600;
}

.swatches-list > ul > li
{
  margin: 8px;
  box-shadow: 0 4px 5px -2px rgba(0, 0, 0, .2),
    0 7px 10px 1px rgba(0, 0, 0, .14),
    0 2px 16px 1px rgba(0, 0, 0, .12);
}

.swatches-list > ul
{
  display: inline-block;
  vertical-align: top;
}

.swatches-list h4
{
  padding: 16px 0;
}

.swatches-list span
{
  opacity: .5;
}

.swatches-list .align-right
{
  width: 68px;
}

.primary-colors code,
.swatches-list code
{
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/pages/colors.vue